//BookClubBooks.jsx 
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const BookClubBooks = () => {
  const [bookClubBooks, setBookClubBooks] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  // Location in bookClubId ", location);

  const bookClubId = location.state.bookClubId;
  const bookClubTitle = location.state.bookClubTitle;
  
  const authState = useSelector(state => state.authReducer);

  
  const [userId, setUserId] = useState(authState.user._id);
  const [selectedBookClubBookId, setSelectedBookClubBookId] = useState(null);

  const fetchBookClubBooks = useCallback(() => {
    const config = {
      url: `/bookclubbooks/club?clubId=${bookClubId}`,
      method: "get",
      headers: { Authorization: authState.token },
    };

    fetchData(config, { showSuccessToast: false })
      .then(data => {
        if (data && Array.isArray(data)) {
          setBookClubBooks(data);
        } else {
          console.error("Invalid response format: BookClub Books not found in response!");
        }
      })
      .catch(error => {
        console.error('Error fetching BookClub Books:', error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookClubBooks();
  }, [authState.isLoggedIn, fetchBookClubBooks]);

  const handleView = (bookClubBookId) => {
    setSelectedBookClubBookId(prevId => (prevId === bookClubBookId ? null : bookClubBookId));
  };

  const handleComments = (id) => {
    setSelectedRecordId(id);
  };

  const handleCommentSave = (id) => {
    setSelectedRecordId(id);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleMembersClick = (bookId, bookTitle, bookClubId, bookClubTitle ) => {
    navigate("/bookclub-bookmembers", { state: { bookId: bookId, bookTitle: bookTitle, clubId: bookClubId, bookClubTitle: bookClubTitle } })
  };

  const sortedBookClubBooks = [...bookClubBooks].sort((a, b) => b.bookTitle - a.bookTitle);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Book Club Books- List</h2>
      </div>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        <div className="border border-gray-300 p-4 mt-4">
          <div className="flex justify-between items-center border-b border-b-gray-300 bg-purple-600">
            <div className='text-xl mt-1 mx-2  text-white w-7/10'>
              <p className='text-yellow-300' >There are {bookClubBooks.length} active books in <strong>{bookClubTitle}</strong></p>
            </div>
          </div>
          {loading ? (
            <div className="spinner-container">
              <div className="spinner">
                <FontAwesomeIcon icon={faSpinner} spin />
              </div>
            </div>
          ) : (
            <div>
              {bookClubBooks.length === 0 ? (
                <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found!!</span>
                </div>
              ) : (
                sortedBookClubBooks.map((bookClubBook, index) => (
                  <div key={bookClubBook._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                    <div className='flex items-center h-4'>
                      <span className='font-medium'>{index + 1}. {bookClubBook.bookTitle}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleView(bookClubBook._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Books"} position={"top"}>
                        <button
                          className="mr-4 text-purple-600 cursor-pointer w-4"
                          style={{ backgroundColor: 'transparent', border: 'none', margin: '0' }}
                          onClick={() => handleMembersClick(bookClubBook.bookId, bookClubBook.bookTitle, bookClubId, bookClubTitle )}
                        >
                          <i className="fa-solid fa-users"></i>
                        </button>
                      </Tooltip>
                      {/* <Tooltip text={"Edit this record"} position={"top"}>
                        <Link to={`/bookclub/${bookClub._id}`} className='mr-4 text-green-600 cursor-pointer'>
                          <i className="fa-solid fa-pen"></i>
                        </Link>
                      </Tooltip> */}
                    </div>
                    <div className='whitespace-pre  text-blue-700'>{bookClubBook.bookClubName}</div>
                    {selectedBookClubBookId === bookClubBook._id && (
                      <div className='bg-gray-200 text-black'>
                        <div>
                          <div>
                            <p><strong>Book Info</strong></p>
                            <p><strong>Name:</strong> {bookClubBook.bookTitle}</p>
                            <p><strong>Type:</strong> {bookClubBook.bookType}</p>
                            <p><strong>Remarks:</strong> {bookClubBook.remarks}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default BookClubBooks;
